import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=9fc69afe&scoped=true&"
import script from "./custom.vue?vue&type=script&lang=tsx&"
export * from "./custom.vue?vue&type=script&lang=tsx&"
import style0 from "./custom.vue?vue&type=style&index=0&id=9fc69afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc69afe",
  null
  
)

export default component.exports